export default "__VITE_ASSET__DXl8NcYu__"